import { Sheet, SheetContent, SheetTrigger } from "@workspace/frontend-ui";
import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import RewardsButton from "../RewardsButton";
import RewardCenter from "./RewardCenter";

const RewardCenterSheet: FC = () => {
  const {
    state: { progress, button, visibility },
    send,
  } = useRewardCenter();

  return (
    <Sheet
      open={visibility?.isOpen}
      onOpenChange={() => {
        send("rewardCenter", { type: "toggleVisibility" });
      }}
    >
      <SheetTrigger asChild>
        <span className="inline-flex">
          <RewardsButton
            progress={progress ?? 0}
            status={button?.hasClaimable ? "claimable" : "none"}
            expanded={visibility?.isOpen}
          />
        </span>
      </SheetTrigger>
      <SheetContent
        data-slot="reward-center"
        side="bottom"
        showCloseButton={false}
        aria-describedby={undefined}
        className="gap-0 rounded-t-3xl bg-background p-4 data-[side=bottom]:h-[calc(100dvh-4rem)] data-[side=bottom]:border-t-0"
        overlayClassName="bg-black/50 supports-backdrop-filter:backdrop-blur-none"
      >
        <RewardCenter layout="sheet" />
      </SheetContent>
    </Sheet>
  );
};

export default RewardCenterSheet;
